import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loading", "triggerButton"];
import { View } from 'foundations-components/components/View';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { AIShimmer } from '../loading/AILoadingShimmer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AITextInput = _ref => {
  let {
      loading = false,
      triggerButton
    } = _ref,
    aiTextInputProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AIShimmer, {
    isLoading: loading,
    paddingRight: 36,
    paddingLeft: 12,
    paddingTop: 6,
    marginRight: 2,
    marginLeft: 2,
    marginBottom: 2,
    marginTop: 2,
    children: /*#__PURE__*/_jsxs(View, {
      position: "relative",
      children: [/*#__PURE__*/_jsx(View, {
        zIndex: 1,
        position: "absolute",
        insetBlockStart: "200",
        insetInlineEnd: "200",
        backgroundColor: "fill-field-default",
        paddingInlineStart: "100",
        children: triggerButton
      }), /*#__PURE__*/_jsx(TextInput, Object.assign({}, aiTextInputProps))]
    })
  });
};
AITextInput.displayName = 'AITextInput';